import * as React from 'react';
import { useSelector } from 'react-redux';

import { AuthorAsideBrand, IAuthorAsideBrandProps } from '../../components/author_aside_brand';
import { selectAgentLevelInfo } from '../../selectors';
import { selectAgent } from '../../selectors/selectAgent';
import { showCountrysideBuilderBadge } from '../../utils/suburban';
import { selectAgentReviews, selectCompanyFoundationTime, selectDeveloper, selectOffer } from './selectors/selectors';

export const AuthorAsideBrandContainer = () => {
  const props: IAuthorAsideBrandProps = {
    agent: useSelector(selectAgent),
    agentReviews: useSelector(selectAgentReviews),
    companyFoundationTime: useSelector(selectCompanyFoundationTime),
    developer: useSelector(selectDeveloper),
    offer: useSelector(selectOffer),
    showCountrysideBuilderBadge: useSelector(showCountrysideBuilderBadge),
    agentLevelInfo: useSelector(selectAgentLevelInfo),
  };

  return <AuthorAsideBrand {...props} />;
};
